var map = {
	"./ZX.png": "ZTna"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MqB/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/enterImg ^\.\/ZX.*\.png$
// module id = MqB/
// module chunks = 1